import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { SessionRecord } from "../models/session-record";

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: 2px solid rgba(64, 87, 109, 0.07);
  border-radius: 8px;
  cursor: pointer;
  background: white;

  &:hover {
    border-color: rgba(64, 87, 109, 0.15);
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Detail = styled.span`
  font-size: 12px;
  color: #8c959f;
`;

const RejoinLabel = styled.span`
  font-size: 12px;
  color: #6366f1;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 12px;
`;

function timeAgo(isoDate: string): string {
  const seconds = Math.floor(
    (Date.now() - new Date(isoDate).getTime()) / 1000
  );

  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

interface Props {
  session: SessionRecord;
}

const SessionCard = ({ session }: Props) => {
  const navigate = useNavigate();

  return (
    <Card onClick={() => navigate(`/presentation/${session.magicId}`)}>
      <Info>
        <Title>{session.title || "Untitled Presentation"}</Title>
        <Detail>
          {session.lastSlide && session.totalSlides
            ? `Slide ${session.lastSlide} of ${session.totalSlides}`
            : session.totalSlides
            ? `${session.totalSlides} slides`
            : ""}
          {session.lastActiveAt && ` · ${timeAgo(session.lastActiveAt)}`}
        </Detail>
      </Info>
      <RejoinLabel>Rejoin</RejoinLabel>
    </Card>
  );
};

export default SessionCard;
